module.exports = __webpack_public_path__ + "static/media/vikala-lose.faaeaa53.png";